import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

// Components
import { Text } from '@beef/ui-kit';

// Styles
import styles from './styles.pcss';

const cn = classNames.bind(styles);

const DiscountDescription = ({ className, children }) => (
  <div className={cn('box', className)}>
    <Text size="size6-m">
      {children}
    </Text>
  </div>
);

DiscountDescription.propTypes = {
  children: PropTypes.string,
  className: PropTypes.string,
};

export { DiscountDescription };
